export default 'full-document-deleted';
